import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { RootState } from "../Store/store";

// @ts-ignore
export const useAppDispatch = () => useDispatch<any>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
